<div *ngFor="let asset of this.assets"><button class="btn btn-sm btn-outline-dark py-0 my-1 px-0 border-0" ></button> {{asset}}</div>